var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_69",
    d: "M17.4667 7.4023L13.5152 11.3466V2H10.4848V11.3466L6.53333 7.4023L4.38788 9.54386L12 17.1422L19.6121 9.54386L17.4667 7.4023ZM18.9697 13.2281H22V22H2V13.2281H5.0303V18.9752H18.9697V13.2281Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLoadIcon);
export default __webpack_public_path__ + "static/media/downLoad_icon.8e927110452eac6df8995140eada5254.svg";
export { ForwardRef as ReactComponent };